import TradingViewPage from '@/modules/trading-view/trading-view-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/trading-view/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TradingViewPage />;
}
